module.exports = __webpack_public_path__ + "img/sicon_04.7b57a76a.png";